import { useApiFetch } from '~/composables/useApiFetch';
import type { CreateRole, PermissionsGroupRawData, Role, UserAuthApi } from '~/types/role';

export async function getAllRolesApi(): Promise<Role[]> {
  const response = await useApiFetch('/role/all', {
    method: 'GET',
    requireAuth: true,
  });
  return await response.json();
}

export async function updateMemberRolesApi(
  params: { uid: number; id: number },
  role_uuids: string[]
): Promise<void> {
  const { uid, id } = params;
  // 如果 uid 為 0（用戶尚未註冊），則使用 id
  const targetUid = uid !== 0 ? uid : id;
  await useApiFetch('/role/member/join', {
    method: 'POST',
    requireAuth: true,
    body: JSON.stringify({ uid: targetUid, role_uuids }),
  });
}

export async function createRoleApi(role: CreateRole): Promise<number> {
  // 確保 bg_color 和 text_color 為數字型別
  const roleData = {
    ...role,
    bg_color:
      typeof role.bg_color === 'string' ? Number.parseInt(role.bg_color, 10) : role.bg_color,
    text_color:
      typeof role.text_color === 'string' ? Number.parseInt(role.text_color, 10) : role.text_color,
  };

  const response = await useApiFetch('/role', {
    method: 'POST',
    requireAuth: true,
    body: JSON.stringify(roleData),
  });
  return await response.json();
}

export async function updateRoleApi(role: Role): Promise<void> {
  await useApiFetch('/role', {
    method: 'PUT',
    requireAuth: true,
    body: JSON.stringify(role),
  });
}

export async function updateRoleRulesApi(
  role_uuid: string,
  permissions_keys: string[]
): Promise<void> {
  await useApiFetch('/role/permissions/update', {
    method: 'PUT',
    requireAuth: true,
    body: JSON.stringify({ role_uuid, permissions_keys }),
  });
}

export async function deleteRoleApi(id: number): Promise<boolean> {
  const response = await useApiFetch(`/role?id=${id}`, {
    method: 'DELETE',
    requireAuth: true,
  });
  return await response.json();
}

export async function getMemberRulesApi(): Promise<string[]> {
  const response = await useApiFetch('/role/member/permissions', {
    method: 'GET',
    requireAuth: true,
  });
  return await response.json();
}

export async function getPermissionsGroupsApi(): Promise<PermissionsGroupRawData[]> {
  const response = await useApiFetch('/role/api-groups', {
    method: 'GET',
    requireAuth: true,
  });
  return await response.json();
}

export async function getRoleApi(role_uuid: string): Promise<Role> {
  const response = await useApiFetch(`/role?role_uuid=${role_uuid}`, {
    method: 'GET',
    requireAuth: true,
  });
  return await response.json();
}

export async function getAllUserAuthApisApi(): Promise<UserAuthApi[]> {
  const response = await useApiFetch('/role/apis', {
    method: 'GET',
    requireAuth: true,
  });
  return await response.json();
}
